import { createStore } from 'vuex'

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: true,
  id: null,
  groupId: null,
  agileCodeOptions: null,
  isFocused: false,
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  setFormId (state, formId) {
    state.id = formId
  },
  setGroupId (state, groupId) {
    state.groupId = groupId
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

const actions = {
  setFormId({ commit }, formId) {
    commit('setFormId', formId)
  },
  setGroupId({ commit }, groupId) {
    commit('setGroupId', groupId)
  },
}
const getters = {
  getFormId(state) {
    return state.id
  },
  getGroupId(state) {
    return state.groupId
  },
}

export default createStore({
  state,
  mutations,
  actions,
  getters
})
